import eventBus from "../services/event-bus";
import elementExists from "../utils/element-exists";
const CartCount = function ($selector = '[sh-cart-count]') {
  const _this = {};
  const CartService = Shopify.cartService;
  
  _this.classes = {
    empty: 'empty'
  }
  
  _this.elements = document.querySelectorAll($selector);
  
  const updateCount = (event) => {
    _this.itemCount = CartService.cart.item_count;
    
    _this.elements.forEach(el => {
      if( _this.itemCount == 0 ){
        el.classList.add(_this.classes.empty);
      }else{
        el.classList.remove(_this.classes.empty);
      }
      el.innerText = _this.itemCount;
    });
  }

  if (elementExists(_this.elements)) {
    eventBus.on(eventBus.types.CartUpdated, updateCount);
    eventBus.on(eventBus.types.QuantityUpdated, updateCount);
  }
}

export default CartCount;

